<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="区域名称">
            <span v-if="detailData.areaId === 0" class="global-tag">全局配置</span>
            <span v-else>{{ detailData.areaName || '-' }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="角色类型">
            <a-tag :color="getRoleTypeColor(detailData.roleType)">
              {{ getRoleTypeText(detailData.roleType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="分销比例值">
            <span class="ratio-text">{{ detailData.ratioValue || 0 }}%</span>
          </a-descriptions-item>
          <a-descriptions-item label="是否启用">
            <a-tag :color="detailData.enable === 1 ? 'green' : 'red'">
              {{ detailData.enable === 1 ? '是' : '否' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否继承上级规则">
            <a-tag :color="detailData.isInherit === 1 ? 'green' : 'orange'">
              {{ detailData.isInherit === 1 ? '是' : '否' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="生效时间" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="比例生效开始时间">
            {{ detailData.startTime || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="比例生效结束时间">
            {{ detailData.endTime || '-' }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="其它信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">
            <a-tooltip v-if="detailData.remark" :title="detailData.remark">
              <span class="text-ellipsis">{{ detailData.remark || '无备注' }}</span>
            </a-tooltip>
            <span v-else>无备注</span>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getProportionDetail } from '@/api/profitSharing/proportion'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '分销比例配置详情'
    },
  },
  methods: {
    init(record) {
      this.visible = true
      if (record && record.id) {
        this.loadDetail(record.id)
      } else {
        this.detailData = {}
      }
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getProportionDetail(id)
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return time
    },
    getRoleTypeText(roleType) {
      const map = {
        1: '平台',
        2: '总代理',
        3: '门店',
      }
      return map[roleType] || '-'
    },
    getRoleTypeColor(roleType) {
      const map = {
        1: 'blue',
        2: 'green',
        3: 'orange',
      }
      return map[roleType] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.ratio-text {
  color: #1890ff;
  font-weight: 500;
  font-size: 14px;
}

.global-tag {
  color: #ff4d4f;
  font-weight: 500;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.ant-descriptions-title) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.ant-descriptions-item-label) {
  white-space: nowrap;
}
</style>
